<template>
    <div id="modals">
        <NonExportableTool />
        <ColourMatchToolNotice />

        <modalResetScene />
        <modalNewImage />

        <modalNewCandidate />
        <modalCreateCustomLutsFolder />
        <modalImportCustomLuts />
        <modalEditCustomLuts />
        <modalRenameCustomLutsFolder />
        <modalRenameCustomLut />
        <modalDeleteCustomCategory />
        <modalDeleteCustomLut />

        <CustomLutV2CreateLutFolder />
        <CustomLutV2ImportLut />
        <CustomLutV2EditLut />
        <CustomLutV2RenameLutFolder />
        <CustomLutV2RenameLut />
        <CustomLutV2DeleteLutFolder />
        <CustomLutV2DeleteLut />

        <modalNewMatch />
        <modalDeleteAllMedia />

        <modalColorWorkflowNotification />

        <fileCopyTo />
        <FailedProcessing />
        <FailedUploading />
        <copyCandidateFrom />
        <applyGradeTo />
        <applyGradeFrom />

        <createLayout />
        <deleteLayout />
        <renameLayout />

        <createPreset />
        <deletePreset />
        <deletePresetFolder />
        <importPreset />
        <presetFileTypeNotSupported />
        <presetInvalidChecksum />
        <presetTransformsMismatch />
        <presetNonColourManagedWorkflow />

        <ColourMatch />
        <ColourMatchV2 />
        <AdvancedColourMatchV2 />
        <AIColourExtractV2 />
        <AIColourMatchModal />
        <AIColourMatchV2Modal />

        <NotAvailableInFree />

        <PurchaseProduct />

        <CompareView />

        <SaveAllAsCandidatesProcessing />
        <SaveAllAsCandidatesUnprocessedList />

        <NeuralFilmAIProcessing />
        <NeuralFilmAIUnprocessedList />
    </div>

</template>

<script>
import modalResetScene from "@/views/templates/modals/reset-scene";
import modalNewImage from "@/views/templates/modals/new-image";
import modalNewCandidate from "@/views/templates/modals/new-candidate";

import modalCreateCustomLutsFolder from "@/views/templates/modals/create-custom-luts-folder";
import modalImportCustomLuts from "@/views/templates/modals/import-custom-luts";
import modalEditCustomLuts from "@/views/templates/modals/edit-custom-luts";
import modalRenameCustomLutsFolder from "@/views/templates/modals/rename-custom-luts-folder";
import modalRenameCustomLut from "@/views/templates/modals/rename-custom-lut";
import modalDeleteCustomCategory from "@/views/templates/modals/delete-custom-luts-folder";
import modalDeleteCustomLut from "@/views/templates/modals/delete-custom-lut";

import CustomLutV2CreateLutFolder from "@/views/templates/modals/CustomLutV2/CreateLutFolder.vue";
import CustomLutV2ImportLut from "@/views/templates/modals/CustomLutV2/ImportLut.vue";
import CustomLutV2EditLut from "@/views/templates/modals/CustomLutV2/EditLut.vue";
import CustomLutV2RenameLutFolder from "@/views/templates/modals/CustomLutV2/RenameLutFolder.vue";
import CustomLutV2RenameLut from "@/views/templates/modals/CustomLutV2/RenameLut.vue";
import CustomLutV2DeleteLutFolder from "@/views/templates/modals/CustomLutV2/DeleteLutFolder.vue";
import CustomLutV2DeleteLut from "@/views/templates/modals/CustomLutV2/DeleteLut.vue";

import modalDeleteAllMedia from "@/views/templates/modals/delete-all-media.vue";
import modalNewMatch from "@/views/templates/modals/new-match";
import modalColorWorkflowNotification from "@/views/templates/modals/color-workflow-notification";

import fileCopyTo from "@/components/app/files/CopyTo";
import FailedProcessing from "@/components/app/files/modals/FailedProcessing";
import FailedUploading from "@/components/app/files/modals/FailedUploading";
import copyCandidateFrom from "@/components/app/files/CopyCandidateFrom.vue";
import applyGradeTo from "@/components/app/grade/ApplyGradeTo.vue";
import applyGradeFrom from "@/components/app/grade/ApplyGradeFrom.vue";

import NonExportableTool from "@/components/app/blocks/warnings/NonExportableTool.vue";
import ColourMatchToolNotice from "@/components/app/blocks/warnings/ColourMatchToolNotice.vue";

import createLayout from "@/components/app/layouts/Create";
import deleteLayout from "@/components/app/layouts/Delete";
import renameLayout from "@/components/app/layouts/Rename";

import createPreset from "@/components/app/presets/CreatePreset.vue";
import deletePreset from "@/components/app/presets/DeletePreset.vue";
import deletePresetFolder from "@/components/app/presets/DeletePresetFolder.vue";
import importPreset from "@/components/app/presets/ImportPreset.vue";
import presetFileTypeNotSupported from "@/components/app/presets/warnings/FileTypeNotSupported";
import presetInvalidChecksum from "@/components/app/presets/warnings/InvalidChecksum";
import presetTransformsMismatch from "@/components/app/presets/warnings/TransformsMismatch";
import presetNonColourManagedWorkflow from "@/components/app/presets/warnings/NonColourManagedWorkflow";

import ColourMatch from "@/components/app/blocks/ColourMatch/V1/ColourMatchModal.vue";
import ColourMatchV2 from "@/components/app/blocks/ColourMatch/V2/ColourMatchV2Modal.vue";
import AdvancedColourMatchV2 from "@/components/app/blocks/ColourMatch/V2/AdvancedColourMatchV2Modal.vue";
import AIColourExtractV2 from "@/components/app/blocks/AIColourExtract/V2/AIColourExtractModal";
import AIColourMatchModal from "@/components/app/blocks/AIColourMatch/V1/AIColourMatchModal.vue";
import AIColourMatchV2Modal from "@/components/app/blocks/AIColourMatch/V2/AIColourMatchV2Modal.vue";

import NotAvailableInFree from "@/views/templates/modals/not-available-in-free";
import PurchaseProduct from "@/views/templates/modals/product-purchase";
import CompareView from '@/views/templates/modals/compare-view';

import SaveAllAsCandidatesProcessing from '@/views/templates/modals/SaveAllAsCandidatesProcessing';
import SaveAllAsCandidatesUnprocessedList from '@/views/templates/modals/SaveAllAsCandidatesUnprocessedList';

import NeuralFilmAIProcessing from '@/views/templates/modals/NeuralFilmAIProcessing.vue'
import NeuralFilmAIUnprocessedList from '@/views/templates/modals/NeuralFilmUnprocessedList.vue'

export default {
    name: "Modals",
    components: {
        NotAvailableInFree,
        NonExportableTool,
        ColourMatchToolNotice,

        modalResetScene,
        modalNewImage,
        modalNewCandidate,

        modalCreateCustomLutsFolder,
        modalImportCustomLuts,
        modalEditCustomLuts,
        modalRenameCustomLutsFolder,
        modalRenameCustomLut,
        modalDeleteCustomCategory,
        modalDeleteCustomLut,

        CustomLutV2CreateLutFolder,
        CustomLutV2ImportLut,
        CustomLutV2EditLut,
        CustomLutV2RenameLutFolder,
        CustomLutV2RenameLut,
        CustomLutV2DeleteLutFolder,
        CustomLutV2DeleteLut,

        modalDeleteAllMedia,
        modalNewMatch,
        modalColorWorkflowNotification,

        fileCopyTo,
        copyCandidateFrom,
        applyGradeTo,
        applyGradeFrom,
        FailedProcessing,
        FailedUploading,

        createLayout,
        deleteLayout,
        renameLayout,

        createPreset,
        deletePreset,
        deletePresetFolder,
        importPreset,
        presetFileTypeNotSupported,
        presetInvalidChecksum,
        presetTransformsMismatch,
        presetNonColourManagedWorkflow,

        ColourMatch,
        ColourMatchV2,
        AdvancedColourMatchV2,
        AIColourExtractV2,
        AIColourMatchModal,
        AIColourMatchV2Modal,

        PurchaseProduct,
        CompareView,

        SaveAllAsCandidatesProcessing,
        SaveAllAsCandidatesUnprocessedList,

        NeuralFilmAIProcessing,
        NeuralFilmAIUnprocessedList,
    }
}
</script>